import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchProjectContact } from '../api/projects.api';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { Id, ProjectContact } from '@/shared/types/domain';

/**
 * Contato do responsável (decisão 30).
 *
 * `enabled` é de quem chama, e aqui ele carrega uma regra: **para quem não tem
 * `reviewProject` a consulta nem dispara**, e a linha do responsável continua
 * sendo só o nome. Dado pessoal não se busca "por via das dúvidas" (RNF-S09) —
 * a RPC recusaria de qualquer forma, mas uma requisição que sempre falha é
 * ruído no log e uma porta a mais para alguém afrouxar depois.
 */
export function useProjectContact(
  projectId: Id | undefined,
  enabled: boolean,
): UseQueryResult<ProjectContact | null> {
  return useQuery({
    queryKey: queryKeys.projects.contact(projectId ?? ''),
    queryFn: () => fetchProjectContact(projectId as Id),
    enabled: Boolean(projectId) && enabled,
    staleTime: 5 * 60_000,
  });
}
